import axios from 'axios'
import { BillingCycle, PlanEnums, StripeStatusEnums } from '../screenhub-shared/enum/stripe.enum'
import { getProPriceFor, getStandardPriceFor, PricingSubscription } from './standard-pricing'

const { REACT_APP_API_GATEWAY_URL } = process.env

export const isActiveSubscription = (subscription) => {
  return subscription?.status === StripeStatusEnums.ACTIVE ||
         subscription?.status === StripeStatusEnums.TRIALING ||
         subscription?.status === StripeStatusEnums.INCOMPLETE;
}

// Standard and Pro are date-gated — see standard-pricing.ts. Cellular stays 20 / 240.
export const getItemPrice = (
  chosenPlan: PlanEnums,
  billingCycle: BillingCycle,
  subscription?: PricingSubscription | null
) => {
  switch (chosenPlan) {
    case PlanEnums.CELLULAR_PLAN:
      return billingCycle === BillingCycle.MONTH ? 20.00 : 240.00
    case PlanEnums.PRO_PLAN:
    case PlanEnums.CIRRUS_HARDWARE_PRO_PLAN:
    case PlanEnums.CIRRUS_WINDOWS_PRO_PLAN:
      return getProPriceFor(subscription, chosenPlan, billingCycle)
    case PlanEnums.PREMIUM_PLAN:
    case PlanEnums.CIRRUS_HARDWARE_PLAN:
    case PlanEnums.CIRRUS_WINDOWS_PLAN:
      return getStandardPriceFor(subscription, chosenPlan, billingCycle)
    default:
      return 0
  }
}

export const totalPrice = (
  qty: number,
  chosenPlan: PlanEnums,
  billingCycle: BillingCycle,
  subscription?: PricingSubscription | null
) => {
  return (getItemPrice(chosenPlan, billingCycle, subscription) * qty).toFixed(2)
}

export const paidQuantity = (qty: number, plan: PlanEnums, cirrusStandardQty: number): number => {
  switch (plan) {
    case PlanEnums.CIRRUS_HARDWARE_PLAN:
    case PlanEnums.CIRRUS_WINDOWS_PLAN:
      return qty > cirrusStandardQty ? qty - cirrusStandardQty : 0;
    default:
      return qty;
  }
}